import { Button } from "@/components/ui";
import { FormProvider } from "react-hook-form";
import useAnnouncements from "./useAnnouncements";
import {
  FormFileInput,
  FormSectionHeader,
  FormTextarea,
  Dialog,
  FormLabel,
  DatePicker,
  Loader,
  Select,
  Heading,
} from "@/components";
import { FLASH_1, FLASH_2, NEWS_1, NEWS_2 } from "./consts";
import moment from "moment";

const Announcements = () => {
  const {
    form,
    onSubmit,
    requiredFields,
    newsletter1Ref,
    newsletter2Ref,
    expiredDate1,
    expiredDate2,
    onSaveDate,
    setDate,
    date,
    open,
    setOpen,
    onChangeClick,
    isUpdatePending,
    isNewsSettingsLoading,
    isNewsSettingsRefetching,
    isUpdateLetterPending,
    isDeleteLetterPending,
    communityList,
    communityId,
    onCommunityChange,
    isCommunityLoading,
    key,
    hasPermission,
  } = useAnnouncements();
  const { errors } = form.formState;

  return (
    <div className="p-4 md:p-6">
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading title="Announcement" />
        </div>
        <div className="relative w-full sm:w-72 sm:min-w-72 sm:max-w-72 shrink-0">
          <FormLabel>Select Community</FormLabel>
          <Select
            key={key}
            placeholder={""}
            searchPlaceholder={""}
            noDataPlaceholder={"Community No Found"}
            options={communityList?.data?.map((data: any) => ({
              value: data?.communityId?.toString(),
              label: data?.name,
            }))}
            value={communityId?.toString()}
            onChange={onCommunityChange}
            className="h-[36px] w-full"
            disabled={isCommunityLoading}
          />
        </div>
      </div>
      
      {isNewsSettingsLoading || isNewsSettingsRefetching ? (
        <Loader />
      ) : (
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="bg-white mt-[20px] rounded-lg px-[30px] py-[25px]">
              <FormSectionHeader>Flash News</FormSectionHeader>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[30px]">
                <div className="flex flex-col gap-1">
                  <FormTextarea
                    name={FLASH_1}
                    control={form.control}
                    label="Community Flash News 1"
                    placeholder="Please enter"
                    error={errors[FLASH_1]?.message}
                    isRequired={requiredFields.includes(FLASH_1)}
                    disabled={!hasPermission}
                  />
                  {expiredDate1 ? <span className="text-[13px] text-g-300 mt-3">
                    {moment(expiredDate1).diff(moment()) < 0
                      ? "Expired "
                      : "Expiry "}{" "}
                    on {moment(expiredDate1).format("MM/DD/YYYY")}
                  </span> : <></>}
                  <Button
                    variant="ghost"
                    className="shadow-none w-fit p-0 text-[12px] h-[20px] text-primary border-b-primary border-b-1 rounded-none hover:bg-transparent hover:text-primary"
                    onClick={onChangeClick(1)}
                    disabled={!hasPermission}
                  >
                    Change
                  </Button>
                </div>
                <div className="flex flex-col gap-1">
                  <FormTextarea
                    name={FLASH_2}
                    control={form.control}
                    label="Community Flash News 2"
                    placeholder="Please enter"
                    error={errors[FLASH_2]?.message}
                    isRequired={requiredFields.includes(FLASH_2)}
                    disabled={!hasPermission}
                  />
                  {expiredDate2 ? <span className="text-[13px] text-g-300 mt-3">
                    {moment(expiredDate2).diff(moment()) < 0
                      ? "Expired "
                      : "Expiry "}{" "}
                    on {moment(expiredDate2).format("MM/DD/YYYY")}
                  </span> : <></>}
                  <Button
                    variant="ghost"
                    className="shadow-none w-fit p-0 text-[12px] h-[20px] text-primary border-b-primary border-b-1 rounded-none hover:bg-transparent hover:text-primary"
                    onClick={onChangeClick(2)}
                    disabled={!hasPermission}
                  >
                    Change
                  </Button>
                </div>
              </div>
            </div>
            <div className="bg-white mt-[20px] rounded-lg px-[30px] py-[25px]">
              <FormSectionHeader>Newsletter</FormSectionHeader>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[30px]">
                <FormFileInput
                  fileInputRef={newsletter1Ref}
                  name={NEWS_1}
                  control={form.control}
                  label="Newsletter 1"
                  error={errors[NEWS_1]?.message}
                  isRequired={requiredFields.includes(NEWS_1)}
                  accept="application/pdf"
                  maxSize={5} // in MB
                  disabled={!hasPermission}
                />
                <FormFileInput
                  fileInputRef={newsletter2Ref}
                  name={NEWS_2}
                  control={form.control}
                  label="Newsletter 2"
                  error={errors[NEWS_2]?.message}
                  isRequired={requiredFields.includes(NEWS_2)}
                  accept="application/pdf"
                  maxSize={5} // in MB
                  disabled={!hasPermission}
                />
              </div>
            </div>
            {hasPermission ? <div className="flex flex-row justify-end gap-3  py-3">
              <Button
                type="submit"
                disabled={
                  isUpdatePending ||
                  isUpdateLetterPending ||
                  isDeleteLetterPending
                }
              >
                {isUpdatePending ||
                isUpdateLetterPending ||
                isDeleteLetterPending ? (
                  <Loader variant="secondary" />
                ) : (
                  <></>
                )}
                Save
              </Button>
            </div> : <></>}
          </form>
        </FormProvider>
      )}
      <Dialog
        open={open}
        setOpen={setOpen}
        title="Date Change For Flash News 1"
        onSave={onSaveDate}
      >
        <div className="relative">
          <FormLabel>Date</FormLabel>
          <DatePicker setDate={setDate} date={date} />
        </div>
      </Dialog>
    </div>
  );
};

export default Announcements;
